import angular from 'angular';

export default class ModalWindowController {

  static get $inject() {
    return ['$scope', '$uibModal', '$templateCache', '$rootScope', '$translate', '$controller',
      'statusMessage', '$q'];
  }

  constructor($scope, $uibModal, $templateCache, $rootScope, $translate, $controller,
              statusMessage, $q) {
    this.$modal = $uibModal;
    this.$templateCache = $templateCache;
    this.$rootScope = $rootScope;
    this.$translate = $translate;
    this.$controller = $controller;
    this.$scope = $scope;
    this.statusMessage = statusMessage;
    this.$q = $q;

    this.disabled = false;
    this.processing = false;
    this.showSubmitError = false;
    this.onSubmit = angular.noop;

    this.options = $scope.options;

    this.initializeContent();

    this.setProperty('title', 'components.modal-window.title');
    this.setProperty('cancelLabel', 'components.modal-window.label.cancel');
    $q.when(this.setProperty('errorMessage', 'components.modal-window.errorMessage')).then( () => {
      // set default message to be shown when failed promise does not conform to rejection pattern
      this.defaultErrorMessage = this.errorMessage;
    });

    this.setProperty('successMessage', 'components.modal-window.successMessage');
    this.setProperty('icon');
    this.setProperty('template');
    this.setProperty('templateUrl');
    this.setProperty('hideSubmit');
    this.setProperty('doNotShowMessage');
    this.setProperty('instance');
    this.setProperty('showFullscreenToggle');
    this.setProperty('successMessageTimeout');

    this.showCloseButton = typeof this.options.showCloseButton === 'boolean' ?
      this.options.showCloseButton :
      true;

    // do not translate submitLabel to prevent double translation of submit label
    // submit button is a akam-spinner-button,
    // it will translate submitLabel and submitLabelValues
    this.submitLabel = this.options.submitLabel || 'components.modal-window.label.save';
    this.submitLabelValues = this.options.submitLabelValues;

    if (this.instance && this.instance.result) {
      this.instance.result.finally(() => this.contentScope.$destroy());
    }

    this.templateModel = {
      template: this.options.contentTemplate,
      templateUrl: this.options.contentTemplateUrl,
      component: this.options.contentComponent
    };
  }

  initializeContent() {
    let contentController;

    this.contentScope = this.options.contentScope ?
      this.options.contentScope.$new() : this.$rootScope.$new();

    this.contentScope.setOnSubmit = fn => this.onSubmit = fn;
    this.contentScope.disableSubmit = () => this.disabled = true;
    this.contentScope.enableSubmit = () => this.disabled = false;

    this.contentScope.isSubmitDisabled = angular.bind(this, this.isSubmitDisabled);

    const resolve = this.options.contentResolve ? this.options.contentResolve : {};

    if (this.options.contentComponent) {
      this.contentScope.resolve = resolve;
    }

    if (this.options.contentController) {
      contentController = this.$controller(
        this.options.contentController, angular.extend(
          {
            $scope: this.contentScope,
            $modalInstance: this.options.instance
          }, resolve)
      );
    }

    if (this.options.contentControllerAs && contentController) {
      this.contentScope[this.options.contentControllerAs] = contentController;
    }
  }

  isSubmitDisabled() {
    return this.disabled || this.processing;
  }

  setProperty(key, defaultKey) {
    if (defaultKey) {
      return this.$translate(this.options[key] || defaultKey, this.options[`${key}Values`])
        .then(value => this[key] = value)
        .catch(value => this[key] = value);
    } else {
      this[key] = this.options[key];
      return this.key;
    }
  }

  submit() {
    let result;

    this.showSubmitError = false;

    if (angular.isFunction(this.onSubmit)) {
      result = this.onSubmit();
    } else {
      result = this.onSubmit;
    }

    // check to see if the onSubmit returns a promise
    if (result && angular.isFunction(result.then)) {
      this.processing = true;
    }

    this.$q.when(result).then((returnValue) => {
      this.instance.close(returnValue);
      if (!this.doNotShowMessage) {
        this.statusMessage.showSuccess({
          text: this.successMessage,
          timeout: this.successMessageTimeout
        });
      }
    }).catch((errorResult) => {
      if (angular.isString(errorResult)) {
        this.$translate(errorResult)
          .then(value => this.errorMessage = value)
          .catch(value => this.errorMessage = value);
      } else if (angular.isObject(errorResult) && errorResult.i18nKey !== undefined) {
        this.$translate(errorResult.i18nKey, errorResult.i18nKeyValues)
          .then(value => this.errorMessage = value)
          .catch(value => this.errorMessage = value);
      } else {
        this.errorMessage = this.defaultErrorMessage;
      }

      this.processing = false;
      this.showSubmitError = true;
    });

  }
}
